import request from './request.js';
import {requestbody} from './request.js'

export async function templateExquery(params = {

}) {
    return await requestbody('/templateEx/query', 'post', params)
}
export async function templateExadd(params = {

}) {
    return await requestbody('/templateEx/add', 'post', params)
}
export async function getShuizList(params = {
}) {
    return await requestbody('/sys/getShuizList', 'post', params)
}
export async function queryCompanyShuibDict(params = {
}) {
    return await requestbody('/sys/queryCompanyShuibDict', 'post', params)
}
export async function queryCompanySz(params = {
}) {
    return await requestbody('/sys/queryCompanySz', 'post', params)
}
export async function companysPage(params = {
}) {
    return await requestbody('/mapping-rulefunc/companysPage', 'post', params)
}
export async function getTemplate(params = {
}) {
    return await request('/templateEx/getTemplate', 'post', params)
}
export async function templateExdelete(params = {
}) {
    return await requestbody('/templateEx/delete', 'post', params)
}
export async function templateExexport(params = {
}) {
    return await requestbody('/templateEx/export', 'post', params)
}
export async function templateExversionquery(params = {
}) {
    return await requestbody('/templateEx/version/query', 'post', params)
}
export async function getShuibDetailList(params = {
}) {
    return await request('/sys/getShuibDetailList', 'post', params)
}
export async function querytemplatecell(params = {
}) {
    return await requestbody('/templateEx/query/template/cell', 'post', params)
}
export async function templatecellsave(params = {
}) {
    return await requestbody('/template/cell/save', 'post', params)
}
export async function reportTrack(params = {
}) {
    return await requestbody('/templateEx/query/fcs/template', 'post', params)
}
export async function tdsTemplate(params = {
}) {
    return await requestbody('/templateEx/query/tds/template', 'post', params)
}
